/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { day } from './day';

export class calendar extends IceEntity {
    calendar_key: string = "";
    trans_account: string = "";
    account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;

  DAYS: day[] = [];
    gettablename(): string {
        return "CALENDAR";
    };

    hassubtree(ColumnName: string): boolean {
        if (ColumnName.length == 0) return false;
        else if (ColumnName == "DAYS") return true;

        return false;
    }

    getsubtreetablename(ColumnName: string): string {
        if (ColumnName.length == 0) return null;
        else if (ColumnName == "DAYS") return "DAY";

        return null;
    }
}
